import React, { useState } from "react";

export const mainContext = React.createContext();

function Context({ children }) {
  const [contextData, setContextData] = useState({});

  const updateContextData = (_data) => {
    setContextData({ ...contextData, ..._data });
  };

  return (
    <mainContext.Provider value={{ contextData, updateContextData }}>
      {children}
    </mainContext.Provider>
  );
}

export default Context;
